export const CHAT_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  NEW_MESSAGE: 'new message',
  READ_MESSAGE: 'read new message',
  NEW_UNREAD_MESSAGES: 'new unread messages',
  NEW_UNREAD_MESSAGE: 'new unread message',
  NEW_PINNED_MESSAGE: 'new pinned message',
  
  JOIN_ROOM: 'join room',
  LEAVE_ROOM: 'leave room',
  READ_MESSAGES: 'read messages',
  SEND_MESSAGE: 'send message',
  SET_PINNED_MESSAGE: 'set pinned message',
}